import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = "/congrats-box";

function addCongratsBoxApi(params: { heading: string; heading_ar: string; sub_text: string; sub_text_ar: string; file: any }) {
  return api.createWithFile(`${baseUrl}`, params);
}

function getCongratsBoxApi() {
  return api.get(`${baseUrl}`, {});
}

function updateCongratsBoxApi(
  id: number,
  params: {
    file: any;
    heading: string;
    heading_ar: string;
    sub_text: string;
    sub_text_ar: string;
  }
) {
  
  return api.updateWithFile(`${baseUrl}/${id}`, params);
}

function deleteCongratsBoxApi(id: number) {
  return api.delete(`${baseUrl}/${id}`);
}

export { addCongratsBoxApi, getCongratsBoxApi, updateCongratsBoxApi, deleteCongratsBoxApi };
